// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"440":"datadogProfiler","581":"datadogRecorder"}[chunkId] || chunkId) + "." + {"440":"d65378f8","467":"014f28ae","581":"4d90ed66","981":"28740225"}[chunkId] + ".chunk.js";
};